import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { concat, debounce, map } from 'lodash';

import { billingCopaysResource } from '@lib/resources';
import FilterHeader from './components/FilterHeader';
import FilterList from './components/FilterList';
import { useFiltersContext } from '../context/FixedFiltersContext';

interface FiltersBillingItemProps {}

const INITIAL_OPTION_VALUES = [
  {
    id: 'manual',
    name: 'Manual',
  },
];

const FiltersBillingItem: React.FC<FiltersBillingItemProps> = () => {
  const dispatch = useDispatch();
  const [search, setSearch] = useState<string>('');
  const [data, setData] = useState<any[]>(INITIAL_OPTION_VALUES);
  const { setCount } = useFiltersContext();

  useEffect(() => {
    dispatch(
      billingCopaysResource.request({
        url: '/billingcopays',
        method: 'get',
        meta: {
          callbackSuccess: ({ data: { response, size } }: any) => {
            // size + 1 because of the manual option that is fixed
            setCount({ billingItem: size + 1 || 0 });

            if (response.length) {
              setData(
                concat(
                  INITIAL_OPTION_VALUES,
                  map(response, (item: any) => ({
                    id: item._id,
                    name: item.name,
                  })),
                ),
              );
            }
          },
          ignoreErrors: true,
        },
      }),
    );
  }, [dispatch, search, setData, setCount]);

  return (
    <>
      <FilterHeader hideSearchField totalItems={data.length} onSearch={debounce(setSearch, 300)} />
      <FilterList data={data} />
    </>
  );
};

export default FiltersBillingItem;
